import {
  Dialog,
  DialogFooter,
  DialogText,
  FailedCallout,
  ReasonField,
  useReason,
  useToast,
  useCommandMutation,
} from "@amber/ui";
import type { MergeView } from "../../contracts/index";
import { useProfileInvalidation } from "../invalidation";
import { profileCommands } from "../queries";

export function ReverseMergeDialog({ merge, onClose }: { merge: MergeView; onClose: () => void }) {
  const toast = useToast();
  const invalidation = useProfileInvalidation();
  const reason = useReason();
  const mutation = useCommandMutation({
    run: (csrf, text: string) => profileCommands.reverseMerge(merge.id, { reason: text }, csrf),
    ...invalidation,
    onSuccess: (r) => {
      toast.show(
        r.state === "reversing"
          ? "Reverse started; it finishes when editing of an affected transcript ends"
          : "Merge reversed",
      );
      onClose();
    },
  });
  return (
    <Dialog
      open
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
      title="Reverse merge"
      onSubmit={() => {
        if (reason.submit()) mutation.mutate(reason.trimmed);
      }}
      footer={<DialogFooter onClose={onClose} confirm="Reverse merge" pending={mutation.isPending} />}
    >
      <DialogText>
        {merge.role === "survivor" ? merge.other.name : "This profile"} becomes a separate profile again with its
        previous status, and the references the merge moved go back. Changes made after the merge stay on the surviving
        profile.
      </DialogText>
      <ReasonField value={reason.reason} onChange={reason.setReason} error={reason.error} />
      <FailedCallout error={mutation.error} />
    </Dialog>
  );
}
